/**
 * src/data/toolImages.js — ảnh minh hoạ cho các công cụ.
 *
 * Cùng cách làm với glossaryImages.js: ảnh nằm trong public/, tên file = slug công cụ.
 */
export const CO_ANH_CONG_CU = new Set([
  'bang-co-phan-va-pha-loang', 'chi-so-tang-truong', 'chia-co-phan-dong-sang-lap', 'diem-san-sang-goi-von', 'dinh-gia-co-doanh-thu', 'doc-term-sheet', 'dinh-gia-pre-seed',
  'goi-bao-nhieu', 'ho-so-phap-ly-khoi-nghiep', 'kiem-tra-gia-dinh-kinh-te-don-vi', 'mo-phong-vong-goi-von',
  'pitch-deck-10-slide', 'quy-mo-thi-truong', 'quy-phu-hop', 'safe-va-trai-phieu-chuyen-doi', 'tinh-runway',
]);

/** Ảnh lớn trong trang công cụ (1600×900, WebP). */
export const anhCongCu = (slug) => (CO_ANH_CONG_CU.has(slug) ? `/anh/cong-cu/${slug}.webp` : '');
/** Ảnh thu nhỏ trên thẻ công cụ ở trang danh mục (960×540, WebP). */
export const anhNhoCongCu = (slug) => (CO_ANH_CONG_CU.has(slug) ? `/anh/cong-cu/nho/${slug}.webp` : '');
/** Ảnh chia sẻ Facebook/Zalo (1200×630, JPEG). */
export const anhChiaSeCongCu = (slug) => (CO_ANH_CONG_CU.has(slug) ? `/og/cong-cu/${slug}.jpg` : '');
